import React from "react";
import "./TheParentDashboard.css";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Papers from "./imageFiles/Papers.png";

const paperList = [
  { subject: "Science", medium: "English medium", grade: "Grade 5" },
  { subject: "Mathematics", medium: "Tamil medium", grade: "Grade 5" },
  { subject: "Information Communication Technology", medium: "Sinhala Medium", grade: "Grade 5" },
  { subject: "Sinhala Language", medium: "Sinhala medium", grade: "Grade 5" },
  { subject: "History", medium: "English medium", grade: "Grade 5" },
];

export default function AvailablePapers({availablePapers, parent_dashboard_initial_loading, parent_dashboard_data_loading}) {
  return (
    <div className="available-papers-wrapper mt-4 p-3">
      <div className="available-header mb-3">
        <div className="available-tab-title">Latest Available Papers</div>
      </div>

      <div className="available-paper-list">
        {!parent_dashboard_initial_loading && !parent_dashboard_data_loading && availablePapers && availablePapers?.length > 0 ?(

          availablePapers?.map((item, index) => (
            <div className="col-md-12 available-paper-row mb-3" key={index}>
              <div className="col-md-11 available-paper-info px-0">
                <div className="col-md-6 available-paper-info px-0">
                  <img
                    src={Papers}
                    className="paper-icon me-2"
                    alt="subject-icon"
                  />
                  <span className="subject-name">{item?.assess_name || "N/A"}</span>
                </div>
                <div className=" col-md-6 subject-info">
                  <div className="col-md-6">
                    <span className="subject-name">{item?.subject_name || "N/A"}</span>
                  </div>
                  <div className="col-md-6">
                    <span className="subject-medium ms-2">{item?.language_name || "N/A"}</span>
                  </div>
                </div>
              </div>
              <div className="grade-pill col-md-1">Grade {item?.grade_name || "N/A"}</div>
            </div>
          ))

        ):(
          parent_dashboard_initial_loading || parent_dashboard_data_loading?(
            <div >Loading...</div>
          ):(
            <div >No Papers</div>
          )
          
        )}
      </div>
    </div>
  );
}
